if (!customElements.get('bcm-mobile-addons')) {
  customElements.define('bcm-mobile-addons', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-config]').textContent);
      this.section = this.closest('section');
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.hanger = this.querySelector('[data-hanger]');
      this.music = this.querySelector('[data-music]');
      this.summary = this.querySelector('[data-total]');
      this.error = this.querySelector('[data-error]');
      this.editKey = new URL(location.href).searchParams.get('edit-set');
      this.onSubmit = this.submit.bind(this);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.addEventListener('change', () => this.update());
      this.onVariant = () => this.update();
      this.section.addEventListener('change', this.onVariant);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.form, {subtree:true, attributes:true, attributeFilter:['value']});
      this.load();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.section?.removeEventListener('change', this.onVariant);
      this.observer?.disconnect();
    }
    async load() {
      try {
        const res = await fetch('/products/' + this.dataset.bundle + '.js');
        if (!res.ok) throw new Error('Set unavailable');
        this.bundle = await res.json();
        if (this.editKey) {
          const cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
          const line = cart.items.find(x => x.key === this.editKey);
          if (line && this.bundle.variants.some(v => v.id === line.variant_id) && String(line.properties?._bcm_mobile_variant) === String(this.variant()?.id)) {
            this.editLine = line;
            this.hanger.checked = true;
            this.music.checked = true;
            const quantity = this.section.querySelector('[name="quantity"]');
            if (quantity) quantity.value = line.quantity;
            this.querySelector('[data-heading]').textContent = 'Update your set';
          } else this.editKey = null;
        }
        this.hidden = false;
        this.update();
      } catch (_) { this.hidden = true; }
    }
    variant() {
      const id = new FormData(this.form).get('id');
      return this.data.variants.find(v => String(v.id) === String(id));
    }
    bundleVariant() {
      const v = this.variant();
      if (!v || !this.bundle) return null;
      if (this.data.variants.length === 1 && this.bundle.variants.length === 1) return this.bundle.variants[0];
      return this.bundle.variants.find(b => b.title === v.title || JSON.stringify(b.options) === JSON.stringify(v.options));
    }
    money(n) { return new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',maximumFractionDigits:2}).format(n/100); }
    update() {
      if (!this.bundle) return;
      const v = this.variant(), bv = this.bundleVariant();
      if (!v) return;
      const h = this.hanger.checked, m = this.music.checked;
      const count = Math.max(1, Number(new FormData(this.form).get('quantity')) || 1);
      const separate = v.price + this.data.hanger.price + this.data.music.price;
      const offer = bv && bv.available && bv.price === 11900 && v.price === 5600;
      this.hanger.disabled = !this.data.hanger.available;
      this.music.disabled = !this.data.music.available;
      const total = h && m && offer ? bv.price : v.price + (h ? this.data.hanger.price : 0) + (m ? this.data.music.price : 0);
      this.summary.textContent = 'Total: ' + this.money(total * count) + (h && m && offer ? ' · Save ' + this.money((separate - bv.price) * count) : '');
      this.querySelector('[data-offer]').textContent = offer ? 'Add both to complete your set for A$119 — save A$20.' : 'Choose the finishing touches for your nursery.';
      this.error.textContent = h && m && !offer ? 'This complete set is currently unavailable. Please choose individual items.' : '';
      this.section.classList.toggle('bcm-has-addons',h || m || !!this.editLine);
    }
    async request(path, body) {
      const r = await fetch(window.Shopify.routes.root + path, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      const result = await r.json();
      if (!r.ok || result.status) throw new Error(result.description || 'We could not update your cart. Please try again.');
      return result;
    }
    async submit(e) {
      const h = this.hanger.checked, m = this.music.checked;
      if (!h && !m && !this.editLine) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (this.busy) return;
      const v = this.variant(), bv = this.bundleVariant();
      if (!v?.available) return;
      if (h && m && (!bv?.available || bv.price !== 11900 || v.price !== 5600)) {this.update(); return;}
      const quantity = Math.max(1, Number(new FormData(this.form).get('quantity')) || 1);
      const items = h && m ? [{id:bv.id,quantity,properties:{Includes:'Mobile + wooden hanger + music box',_bcm_mobile_variant:String(v.id),_bcm_mobile_url:this.data.url}}] : [{id:v.id,quantity},...(h?[{id:this.data.hanger.id,quantity}]:[]),...(m?[{id:this.data.music.id,quantity}]:[])];
      this.busy = true;
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;
      this.error.textContent = '';
      let removed = false;
      try {
        if (this.editLine) {await this.request('cart/change.js',{id:this.editKey,quantity:0});removed=true;}
        await this.request('cart/add.js',{items});
        location.assign(window.Shopify.routes.root + 'cart');
      } catch(err) {
        if (removed) {
          try {await this.request('cart/add.js',{items:[{id:this.editLine.variant_id,quantity:this.editLine.quantity,properties:this.editLine.properties}]});}
          catch (_) {this.error.textContent='Your original set could not be restored. Please check your cart before continuing.';this.busy=false;button.disabled=false;return;}
        }
        this.error.textContent=err.message;
        this.busy=false;button.disabled=false;
      }
    }
  });
}
